<template>
  <div>

    <div class="bar_nav">
      <div class="title">新建群组</div>
      <div class="bar_back_btn" @click="goToJoinedGroups">返回</div>
    </div>
    <div class="bar_empty"></div>

    <div class="form">
      <input class="field" label="名称" placeholder="请输入群组名" type="text" v-model.trim="groupName" />
      <div class="btn_large" @click="createGroup">确定</div>
    </div>

  </div>
</template>

<script>
import { Toast } from 'mint-ui'
export default {
  name: 'CreateGroup',
  data: function () {
    return {
      userId: 0,
      groupName: ''
    }
  },
  created () {
    try {
      this.userId = this.$route.params.userId
    } catch (err) {
      this.$faLogger.error('CreateGroup.vue:created', err)
    }
  },
  methods: {
    async createGroup () {
      try {
        if (!this.groupName) {
          return Toast({
            message: '请输入群名称'
          })
        }
        await this.$faApi.createGroup({
          name: this.groupName
        })
        this.$router.push({ path: `/user/${this.userId}/joined_groups` })
      } catch (err) {
        this.$faLogger.error('CreateGroup.vue:createGroup', err)
      }
    },
    goToJoinedGroups() {
      this.$router.push({ path: `/user/${this.userId}/joined_groups` })
    }
  }
}
</script>

<style scoped lang="scss">
  .main {
    margin: 0 20px;
  }
</style>
